import { render, staticRenderFns } from "./queuePage.vue?vue&type=template&id=610b1fc3&scoped=true&"
import script from "./queuePage.vue?vue&type=script&lang=js&"
export * from "./queuePage.vue?vue&type=script&lang=js&"
import style0 from "./queuePage.vue?vue&type=style&index=0&id=610b1fc3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610b1fc3",
  null
  
)

export default component.exports